<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <currency_rate_table :currencies="content" />
        </div>

        <pagination :allData="currencyRate" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import currency_rate_table from '@/components/application/localization/currency_rate/currency_rate_table.vue';
import CurrencyRate from '@/data/currencyRate.json';
import pagination from '@/layouts/elements/pagination.vue';
import { useFunctionalitiesStore } from '@/store/functionalities';
import { storeToRefs } from 'pinia';

const functionalitiesStore = useFunctionalitiesStore();
const { state } = storeToRefs(functionalitiesStore);

const currencyRate = ref(CurrencyRate.data);

const content = computed(() => state.value.content);
</script>

<style></style>
